import React, { useState, useEffect } from 'react'
import { unitsService } from '../../../_services/units.service'
import LoadingDots from '../../Shared/LoadingDots'

const UnitSelectBtnList = (props) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [unitType, setUnitType] = useState(props.unitType)

  useEffect(() => {

    getData()

  }, [])

  const getData = () => {

    setLoading(true)
    unitsService.getAll(unitType)
      .then((res) => {
        console.log(res.data)
        setData(res.data)
        setLoading(false)
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
      });

  }

  const handleUnitSelect = (val, name) => {

    props.onChange(val, name)

  }

  return (
    loading ?
      <LoadingDots  loading={loading} style={{ minHeight: 150 }} />
      :
      <div>
        {data && data.map((item, index) => (
          <div className="row" key={'unetBtn-' + item.id}>
            <div className="col-sm-12">
              <a onClick={() => handleUnitSelect(item.id, item.name)} className="btn btn-primary btn-block btn-lg btn-unitSelect" disabled={loading}>
                {item.name}
              </a>
            </div>
          </div>
        ))}
      </div>
  )
}

export default UnitSelectBtnList;